import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import Menu from '@/components/Base/Menu';
import {
  CONTENT_POSITION_TYPES,
  CONTENT_TYPES,
  STATIC_SECTIONS,
} from '@/constants';
import {
  useGetContentBlocks,
  useGetTableOfContent,
  usePageProps,
} from '@/hooks';
import { getCurrentPageType } from '@/utils';

import {
  NavigationItem,
  NavigationTitle,
  Number,
  SidebarNavigation,
  StickyWrapper,
  Wrapper,
} from './Sidebar.styles';

function Sidebar() {
  const { params } = usePageProps();

  // Визначаємо тип сторінки залежно від params
  const pageType = getCurrentPageType({ params });
  const scrollTo = (el) => {
    const currentElement = document.getElementById(el);
    currentElement.scrollIntoView();
  };

  useEffect(() => {
    document.addEventListener('scroll', () => {
      const sections = document.querySelectorAll('.sections');
      const navLinks = document.querySelectorAll('.sidebarLink');

      function highlightNavLink() {
        const fromTop = window.scrollY + 150;

        sections.forEach((section) => {
          if (section.offsetTop <= fromTop) {
            navLinks.forEach((link) => {
              if (link.getAttribute('linkid') === section.id) {
                link.classList.add('active');
              } else {
                link.classList.remove('active');
              }
            });
          }
        });
      }

      window.addEventListener('scroll', highlightNavLink);
    });
  }, []);
  const {
    contentBlocks: { [CONTENT_POSITION_TYPES.asideBottom]: content },
  } = useGetContentBlocks();

  const { tableOfContent: navigationItems } = useGetTableOfContent({
    staticContent: STATIC_SECTIONS[pageType],
  });

  return (
    <Wrapper>
      {!!navigationItems?.length && (
        <StickyWrapper $isSticky>
          <SidebarNavigation>
            <NavigationTitle>
              <FormattedMessage id="staticContent.sidebar.navigation.title" />
            </NavigationTitle>

            {navigationItems.map(({ label, id }, index) => (
              <NavigationItem
                $index={index}
                linkid={id}
                key={label}
                onClick={() => scrollTo(id)}
                className="sidebarLink"
              >
                <Number>{index + 1}</Number>

                <p>{label}</p>
              </NavigationItem>
            ))}
          </SidebarNavigation>
        </StickyWrapper>
      )}

      {content?.map(
        ({ items, caption, type }) =>
          !!items?.length &&
          type === CONTENT_TYPES.menu && (
            <Menu caption={caption} items={items} />
          )
      )}
    </Wrapper>
  );
}
export default Sidebar;
